module.exports = __webpack_public_path__ + "static/media/pexels-photo-4.21d4d69f.png";